/**
 * Carregar o leitor de PDF só quando ele for preciso.
 *
 * O pdf.js pesa quase 400 kB e é usado numa tela só: a de importação. Se ele
 * fosse condição para o aplicativo abrir — como era na primeira versão —, uma
 * falha ao buscá-lo derrubaria a carteira, o quadro e os painéis junto, e o
 * escritório ficaria sem enxergar a produção por causa de um arquivo que
 * ninguém ia usar naquele momento.
 *
 * Então: carrega na primeira importação, e quem chama decide o que fazer se
 * não vier.
 */

import { configurarPdfjs } from '@pcp/leitor-os';

// `?url` é como o Vite entrega o endereço final de um arquivo de dentro de um
// pacote. `new URL('pacote/arquivo', import.meta.url)` só funciona para
// caminho relativo; com especificador de pacote ele não resolve, o pdf.js cai
// no "worker falso" e TODA OS vai para a quarentena com a mesma mensagem.
import enderecoDoWorker from 'pdfjs-dist/legacy/build/pdf.worker.mjs?url';

let promessa: Promise<boolean> | null = null;

export function prepararLeitor(): Promise<boolean> {
  promessa ??= (async () => {
    try {
      const pdfjs = await import('pdfjs-dist/legacy/build/pdf.mjs');
      pdfjs.GlobalWorkerOptions.workerSrc = enderecoDoWorker;
      configurarPdfjs(pdfjs);
      return true;
    } catch (erro) {
      console.error('Não consegui carregar o leitor de PDF.', erro);
      promessa = null; // deixa tentar de novo no próximo toque
      return false;
    }
  })();
  return promessa;
}
